<template>
    <li style="cursor: pointer;" class="list-group-item mb-2" :class="detalle ? 'lightgray2-content' : ''">
        <div class="row">
            <div class="col-12 d-flex justify-content-between" @click="detalle = !detalle">
                <span><b>{{ abono.n_abonado }}.</b> {{ abono.name }} {{ abono.surnames }} <b>({{ abono.dni }})</b></span>
                <span>
                    <b v-if="abono.esta_renovado" class="green">{{ $t('perfil.renovado') }}</b>
                    <b v-else class="red">{{ $t('perfil.no_renovado') }}</b>
                </span>
                <span>
                    <i :class="detalle ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
                </span>
            </div>
            <transition name="fade" mode="out-in">
                <div class="col-12" v-if="detalle">
                    <div class="row d-md-flex flex-md-column">
                        <div class="col-12 pt-4 pl-4 d-flex flex-md-row flex-column justify-content-between">
                            <span class="mb-3" v-if="abono.asiento">
                                <b>{{ abono.asiento.region }}</b>, {{ $t('general.fila') }}: <b>{{ abono.asiento.row }}</b>, {{ $t('general.butaca') }}: <b>{{ abono.asiento.seat }}</b>
                            </span>
                            <span class="mb-3">{{ abono.origen }}</span>
                        </div>
                        <div class="col-12 pl-4 pb-4 d-flex flex-md-row flex-column justify-content-between">
                            <span class="mb-3" v-if="abono.descuento"><b>{{ abono.descuento.descripcion }}</b> ({{ abono.precio | formatear_precio }})</span>
                            <span v-if="abono.fecha_alta">{{ $t('perfil.fecha_alta') }}: {{ abono.fecha_alta }}</span>
                        </div>
                        <div v-if="abono.renovacion_automatica" class="col-12 pb-4 pl-4">
                            <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
                                <div class="">
                                    <div class="d-flex flex-column">
                                        <span class="mb-2"><b>{{ $t('perfil.renovacion_automatica') }}</b></span>
                                        <span class="text-muted">{{ $t('perfil.renovacion_automatica_texto') }}</span>
                                    </div>
                                </div>
                                <button class="button col-md-3 ml-md-4 mt-3 mt-md-0" @click="modalDesactivarRenovacion">{{ $t('perfil.desactivar') }}</button>
                            </div>
                        </div>
                        <div :class="abono.esta_renovado ? 'col-12 pt-2' : 'col-12'">
                            <div class="d-flex flex-wrap justify-content-center">
                                <a
                                    v-if="abono.esta_renovado && !abono.lfp_id"
                                    class="button mb-2 mr-2 col-12 col-md-auto text-center"
                                    target="_blank"
                                    :href="abono.url_passbook"
                                >
                                    Passbook / Passwallet
                                </a>
                                <a
                                    v-if="abono.esta_renovado"
                                    class="button mb-2 mr-2 col-12 col-md-auto text-center"
                                    target="_blank"
                                    :href="abono.url_descargar"
                                >
                                    {{ $t('gracias.descargar_pdf_abono') }}
                                </a>
                                <router-link
                                    v-if="abono.activo_temporada_actual && abono.esta_renovado"
                                    :to="{ name: 'liberar-asiento', params: { abono_id: abono.id } }"
                                    class="button mb-2 mr-2 col-12 col-md-auto text-center"
                                >
                                    {{ $t('perfil.liberar_asiento') }}
                                </router-link>
                                <router-link
                                    v-if="abono.activo_temporada_actual && abono.tiene_plazos"
                                    :to="{ name: 'plazos', params: { tipo_plazo: 'abono', tipo_id: abono.id } }"
                                    class="button mb-2 mr-2 col-12 col-md-auto text-center"
                                >
                                    {{ $t('perfil.plazos') }}
                                </router-link>
                                <router-link
                                    v-if="teatro.invitaciones_para_abonados && abono.esta_renovado"
                                    :to="{ name: 'invitaciones', params: { abono_id: abono.id } }"
                                    class="button mb-2 mr-2 col-12 col-md-auto text-center"
                                >
                                    {{ $t('perfil.invitaciones') }}
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div v-if="abono.activo_temporada_actual" class="col-12 m-0 p-0">
                        <AsientosLiberados class="mt-4" :abonado="abono" :font_size="'20'" :text_align="'center'" :show_recuperar="false" />
                    </div>
                </div>
            </transition>
        </div>
        <BorrarModalComponent name="desactivar-renovacion" title="Desactivar renovación"
                              confirmButton="¿Estás seguro que quieres desactivar la renovación automática?" @confirm="confirmarDesactivarRenovacion"
        />

    </li>
</template>

<script>
    import { config } from '@/config.js';
    import AsientosLiberados from '@/components/backend/abonados/AsientosLiberados.vue';
    import BorrarModalComponent from '@/components/backend/components/BorrarModalComponent.vue';

    export default {
        props: ['abono'],
        data() {
            return {
                detalle: false,
                config: config
            }
        },
        methods: {
            getPassbookEnlace(abono) {
                return this.config.CLE + 'passbooknc/' + abono.id + '/' + abono.qr_code;
            },
            modalDesactivarRenovacion() {
                this.$modal.show("desactivar-renovacion");
            },
            confirmarDesactivarRenovacion() {
                if (!this.abono.renovacion_automatica) return;
                this.actualizarRenovacionAutomatica();
            },
            actualizarRenovacionAutomatica() {
                this.$store.dispatch(this.config.getVuexAlias('front.perfil.abono.desmarcar-renovacion-automatica'), {  abonado_id: this.abono.id  })
                    .then(res => {
                        this.$emit('getAbonos');
                    })
                    .catch(error => {
                        console.error('Error al desmarcar la renovación automática:', error);
                    });
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        components: {
            AsientosLiberados,
            BorrarModalComponent
        }
    }
</script>
